import { render, staticRenderFns } from "./guests.vue?vue&type=template&id=49680b4c"
import script from "./guests.vue?vue&type=script&lang=js"
export * from "./guests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports